import http from "../../core/services/http.service";
import {store} from './../../plugins/vuex/index'
import {AppSettings} from "../../shared/AppSettings";
import i18n from "../../shared/i18n";

const ExportsService = {
  generateToken() {
    return http.post('/api/v1/exports/generate-token/');
  },
  scheduleExport(payload) {
    return http.post('/api/v1/exports/download/', payload);
  },
  exportFinancialHistory(payload) {
    return http.post('/api/v1/exports/download/accounting/export/', payload);
  },
  scheduleExportInvoices(payload) {
    return http.post('/api/v1/exports/download/accounting/invoices/', payload);
  },
  schedulePaymentExportInvoices(payload) {
    return http.post('/api/v1/exports/download/accounting/invoice-payments/', payload);
  },
  scheduleExportSettlements(payload) {
    return http.post('/api/v1/exports/download/accounting/settlements/', payload);
  },
  schedulePaymentExportSettlements(payload) {
    return http.post('/api/v1/exports/download/accounting/settlement-payments/', payload);
  },
  async getTableParamsByModelName(vuexModuleName) {
    return await store.dispatch(`${vuexModuleName}/getTableParams`);
  },
  prepareExportUrl(url, params) {
    let searchParams = new URLSearchParams();

    for (let attr in params) {
      if (params[attr] === null || params[attr] === '' || !params[attr]) {
        continue;
      }
      if (typeof params[attr] === "string" || typeof params[attr] === "boolean") {
        searchParams.set(attr, params[attr]);
      } else if (typeof params[attr] === "object") {
        searchParams.set(attr, JSON.stringify(params[attr]));
      }
    }

    return `${AppSettings.url()}${url}?${searchParams.toString()}`
  },
  async prepareRequestExportsParams(exportAttributes, exportVuexModuleName, type, model = null, extraParams = {}) {

    const vuexModuleNameToBackModelNameMap = {
      customer: 'customer',
      sales: 'auction',
      receipts: 'receipt',
      inventory: 'inventory',
      lots: 'reservation',
      bidders: 'bidder',
      bids: 'bid',
      preBids: 'commission_bid',
      invoices: 'invoice',
      settlements: 'settlement',
      'marketing/customer': 'marketing_customer',
    };

    let requestParams = {
      attr: exportAttributes,
      file_type: type,
    };

    if (!model) {
      requestParams = {
        ...requestParams,
        ...await ExportsService.getTableParamsByModelName(exportVuexModuleName),
        model: vuexModuleNameToBackModelNameMap[exportVuexModuleName],
      }
    } else {
      requestParams = {
        ...requestParams,
        ...extraParams,
        model,
      }
    }

    return requestParams
  }
};

export default ExportsService;
export const EXPORT_TYPES = [
  // {type: 'csv', label: i18n.t('CSV')},
  {type: 'xlsx', label: i18n.t('Xlsx')},
];
